var map = {
	"./Algoma University.png": 188,
	"./Brock University.jpg.png": 189,
	"./Carleton University.png": 190,
	"./Huntington University.png": 191,
	"./Lakehead University.png": 192,
	"./Laurentian University.jpg": 193,
	"./McMaster University.png": 194,
	"./Nippissing University.jpg": 195,
	"./OCAD.jpg": 196,
	"./Queens University.png": 197,
	"./Ryerson University.jpg": 198,
	"./St Jeromes University.png": 199,
	"./St Paul University.jpeg.png": 200,
	"./Thorneloe University.png": 201,
	"./Trent University.jpg.png": 202,
	"./UOIT.jpg": 203,
	"./Universite De LOntario Francais.jpg": 204,
	"./University of Guelph.png": 205,
	"./University of Hearst.jpg": 206,
	"./University of Ottawa.png": 207,
	"./University of Sudbury.png": 208,
	"./University of Toronto.png": 209,
	"./University of Waterloo.png": 210,
	"./University of Windsor.png": 211,
	"./Victoria University.png": 212,
	"./Western University.png": 213,
	"./Wilfrid Laurier University.jpg": 214,
	"./York University.jpg": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 187;